export const emptyField = (fieldId: string) => {
  ;(document.getElementById(fieldId) as any).value = ''
}
